/* Choose type of plans shown on payout (PAYMENT_PLAN_TYPE variable)*/
export enum PaymentPlanType {
    TRIAL = "TRIAL",
    SUBSCRIPTION_WITH_TRIAL = "SUBSCRIPTION WITH TRIAL",
    SUBSCRIPTION = "SUBSCRIPTION",
}

export enum PaymentProvider {
    IXOPAY = "ixopay",
    PAYPAL = "paypal",
}
